import Vue from 'vue'

const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})
const percentFormatter = new Intl.NumberFormat('en-US', {
  style: 'percent',
  maximumFractionDigits: 2
})

export function capitalize(str) {
  return str
    ? str
        .toString()
        .charAt(0)
        .toUpperCase() + str.toString().slice(1)
    : ''
}

export function lowerCase(str) {
  return str ? str.toString().toLowerCase() : ''
}

export function usd(number) {
  // return '$' + Math.abs(Math.round(number * 100) / 100).toFixed(2)
  return usdFormatter.format(number)
}

export function percent(number) {
  // return Math.round(number * 100) + '%'
  return percentFormatter.format(number)
}

Vue.filter('capitalize', capitalize)
Vue.filter('lowerCase', lowerCase)
Vue.filter('usd', usd)
Vue.filter('percent', percent)

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function(el) {
    // Focus the element
    el.focus()
  }
})

Vue.directive('longclick', {
  bind: function(el, binding, vNode) {
    //console.log('bound')
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name
      let warn = `[longclick:] provided expression '${
        binding.expression
      }' is not a function, but has to be`
      if (compName) {
        warn += `Found in component '${compName}' `
      }
      console.warn(warn) // eslint-disable-line
    }

    let pressTimer = null
    let pressInterval = null

    const start = e => {
      if (e.type === 'click' && e.button !== 0) {
        return
      }

      if (pressTimer === null) {
        pressTimer = setTimeout(() => {
          pressInterval = setInterval(() => {
            handler()
          }, 100)
          handler()
        }, 400)
      }
    }

    // Cancel Timeout
    const cancel = () => {
      if (pressTimer !== null) {
        clearTimeout(pressTimer)
        pressTimer = null
      }
      if (pressInterval) {
        clearInterval(pressInterval)
        pressInterval = null
      }
    }
    // Run Function
    const handler = e => {
      binding.value(e)
    }

    ;['mousedown', 'touchstart'].forEach(e => el.addEventListener(e, start))
    ;['click', 'mouseout', 'touchend', 'touchcancel'].forEach(e =>
      el.addEventListener(e, cancel)
    )
  }
})
